import { Outlet } from 'react-router';

import { DynamicHeader } from '~/components/DynamicHeader';
import Footer from '~/components/Footer';
import useRegion from '~/hooks/useRegion';

export default function MainMenuTemplate() {
  const region = useRegion();

  return (
    <div className="flex min-h-dvh flex-col">
      <DynamicHeader region={region} />
      <main className="has-[>[data-fill-viewport]]:flex has-[>[data-fill-viewport]]:grow has-[>[data-fill-viewport]]:flex-col">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
